import VueRouter from 'vue-router'

import Login from '@/views/Login'
import NotFound from '@/views/404'
import Home from '@/views/Home'
import Main from '@/views/Main'

import RegistrationsList from '@/views/Spectacles/RegistrationsList'
import RegistrationSettings from '@/views/Spectacles/RegistrationSettings'
import MenusList from '@/views/Menus/MenusList'
import MenuForm from '@/views/Menus/MenuForm'
import PopupsList from '@/views/Popups/PopupsList'
import PopupForm from '@/views/Popups/PopupForm'
import EditionsList from '@/views/Editions/EditionsList'
import EditionForm from '@/views/Editions/EditionForm'
import ColorsList from '@/views/Colors/ColorsList'
import ColorForm from '@/views/Colors/ColorForm'
import StagesList from '@/views/Stages/StagesList'
import StageForm from '@/views/Stages/StageForm'
import PagesList from '@/views/Pages/PagesList'
import PageForm from '@/views/Pages/PageForm'
import WidgetsList from '@/views/Widgets/WidgetsList'
import WidgetForm from '@/views/Widgets/WidgetForm'
import EventsList from '@/views/Events/EventsList'
import EventForm from '@/views/Events/EventForm'
import EventsOrder from '@/views/Events/EventsOrder'
import FolderForm from '@/views/Instagram/FolderForm'
import FoldersList from '@/views/Instagram/FoldersList'
import AttachmentsList from '@/views/Attachments/AttachmentsList'
import SettingsForm from '@/views/Settings/SettingsForm'
import PeriodsList from '@/views/Tickets/PeriodsList'
import PeriodForm from '@/views/Tickets/PeriodForm'
import TicketsList from '@/views/Tickets/TicketsList'
import TicketForm from '@/views/Tickets/TicketForm'
import CustomFormsList from '@/views/CustomForms/CustomFormsList'
import CustomForm from '@/views/CustomForms/CustomForm'
import StandsList from '@/views/Stands/StandsList'
import StandForm from '@/views/Stands/StandForm'
import NewsList from '@/views/News/NewsList'
import NewsForm from '@/views/News/NewsForm'
import CategoriesList from '@/views/Stands/CategoriesList'
import CategoryForm from '@/views/Stands/CategoryForm'
import ImagesList from '@/views/Gallery/Images/ImagesList'
import GalleriesList from '@/views/Gallery/Galleries/GalleriesList'
import GalleryForm from '@/views/Gallery/Galleries/GalleryForm'
import LoungerList from "../views/Loungers/LoungerList";
import LoungerForm from "../views/Loungers/LoungerForm";
import ReservationList from "../views/Loungers/ReservationList";

let routes = [
    {
        path: '/login',
        component: Login,
        name: 'Login',
        hidden: true,
        meta: {
            guests: true
        }
    },
    {
        path: '/404',
        component: NotFound,
        name: '404',
        hidden: true,
        meta: {
            guests: true
        }
    },
    //{ path: '/main', component: Main },
    {
        path: '/',
        component: Home,
        name: 'Home',
        iconCls: 'el-icon-star-on',
        meta: {label: 'Home'},
        hidden: true
    },
    {
        path: '/stages',
        component: Home,
        iconCls: 'fa fa-slideshare',
        meta: {label: 'Sceny i miejsca'},
        children: [
            {
                path: '', component: StagesList, name: 'Stages List', meta: {label: 'Lista'}
            },
            {
                path: 'add', component: StageForm, name: 'Add Stage', meta: {label: 'Dodaj'}
            },
            {
                path: ':id', component: StageForm, name: 'Edit Stage', hidden: true, meta: {label: 'Edytuj scenę'}
            }
        ]
    },
    {
        path: '/tickets',
        component: Home,
        iconCls: 'fa fa-ticket',
        meta: {label: 'Bilety'},
        children: [
            {
                path: 'periods', component: PeriodsList, name: 'Periods List', meta: {label: 'Okresy biletowe'}
            },
            {
                path: 'periods/add', component: PeriodForm, name: 'Add Period', meta: {label: 'Dodaj okres biletowy'}
            },
            {
                path: 'periods/:id',
                component: PeriodForm,
                name: 'Edit Period',
                hidden: true,
                meta: {label: 'Edytuj okresy biletowe'}
            },
            {
                path: '', component: TicketsList, name: 'Tickets List', meta: {label: 'Lista biletów'}
            },
            {
                path: 'add', component: TicketForm, name: 'Add Ticket', meta: {label: 'Dodaj bilet'}
            },
            {
                path: ':id', component: TicketForm, name: 'Edit Ticket', hidden: true, meta: {label: 'Edytuj bilet'}
            }
        ]
    },
    {
        path: '/loungers',
        component: Home,
        iconCls: 'fa fa-sun-o',
        meta: {label: 'Leżaki'},
        children: [
            {
                path: '',
                component: LoungerList,
                name: 'Lounger List',
                meta: {label: 'Lista leżaków'}
            },
            {
                path: 'add',
                component: LoungerForm,
                name: 'Add Lounger',
                meta: {label: 'Dodaj leżak'}
            },
            {
                path: 'reservations',
                component: ReservationList,
                name: 'Reservation List',
                meta: {label: 'Lista rezerwacji'}
            },
            {
                path: ':id',
                component: LoungerForm,
                name: 'Edit Lounger',
                hidden: true,
                meta: {label: 'Edytuj leżak'}
            }
        ]
    },
    {
        path: '/editions',
        component: Home,
        iconCls: 'fa fa-rocket',
        meta: {label: 'Edycje festiwalu'},
        children: [
            {
                path: '', component: EditionsList, name: 'Editions List', meta: {label: 'Lista edycji'}
            },
            {
                path: 'add', component: EditionForm, name: 'Add Edition', meta: {label: 'Dodaj edycję'}
            },
            {
                path: ':id', component: EditionForm, name: 'Edit Edition', hidden: true, meta: {label: 'Edytuj edycję'}
            }
        ]
    },
    {
        path: '/news',
        component: Home,
        iconCls: 'fa fa-newspaper-o',
        meta: {label: 'Newsy'},
        children: [
            {
                path: '', component: NewsList, name: 'News List', meta: {label: 'Lista newsów'}
            },
            {
                path: 'add', component: NewsForm, name: 'Add News', meta: {label: 'Dodaj news'}
            },
            {
                path: ':id', component: NewsForm, name: 'Edit News', hidden: true, meta: {label: 'Edytuj news'}
            }
        ]
    },
    {
        path: '/galleries',
        component: Home,
        iconCls: 'fa fa-photo',
        meta: {label: 'Galerie'},
        children: [
            {
                path: 'images', component: ImagesList, name: 'Images List', hidden: true, meta: {label: 'Zdjęcia'}
            },
            {
                path: '', component: GalleriesList, name: 'Galleries List', meta: {label: 'Lista galerii'}
            },
            {
                path: 'add', component: GalleryForm, name: 'Add Gallery', meta: {label: 'Dodaj galerię'}
            },
            {
                path: ':id', component: GalleryForm, name: 'Edit Gallery', hidden: true, meta: {label: 'Edytuj galerię'}
            }

        ]
    },
    {
        path: '/menu',
        component: Home,
        iconCls: 'fa fa-bars',
        meta: {label: 'Menu'},
        children: [
            {
                path: '', component: MenusList, name: 'Menus List', meta: {label: 'Lista menu'}
            },
            {
                path: ':id', component: MenuForm, name: 'Edit Menu', hidden: true, meta: {label: 'Edytuj menu'}
            }
        ]
    },
    {
        path: '/pages',
        component: Home,
        iconCls: 'fa fa-desktop',
        meta: {label: 'Podstrony'},
        children: [
            {
                path: '', component: PagesList, name: 'Pages List', meta: {label: 'Lista stron'}
            },
            {
                path: 'add', component: PageForm, name: 'Add Page', meta: {label: 'Dodaj stronę'}
            },
            {
                path: ':slug', component: PageForm, name: 'Edit Page', hidden: true, meta: {label: 'Edytuj stronę'}
            }
        ]
    },
    {
        path: '/widgets',
        component: Home,
        iconCls: 'fa fa-cubes',
        meta: {label: 'Widgety globalne'},
        children: [
            {
                path: '', component: WidgetsList, name: 'Widgets List', meta: {label: 'Lista'}
            },
            {
                path: ':type/add',
                component: WidgetForm,
                name: 'Add Widget',
                hidden: true,
                meta: {label: 'Dodaj widget'}
            },
            {
                path: ':id', component: WidgetForm, name: 'Edit Widget', hidden: true, meta: {label: 'Edytuj widget'}
            }
        ]
    },
    {
        path: '/popups',
        component: Home,
        iconCls: 'fa fa-window-close-o',
        meta: {label: 'Popupy'},
        children: [
            {
                path: '', component: PopupsList, name: 'Popups List', meta: {label: 'Lista popupów'}
            },
            {
                path: 'add', component: PopupForm, name: 'Add Popup', meta: {label: 'Dodaj popup'}
            },
            {
                path: ':id', component: PopupForm, name: 'Edit Popup', hidden: true, meta: {label: 'Edytuj popup'}
            }
        ]
    },
    {
        path: '/events/concerts',
        component: Home,
        iconCls: 'fa fa-music',
        meta: {label: 'Koncerty'},
        children: [
            {
                path: '',
                component: EventsList,
                name: 'Concerts List',
                meta: {label: 'Lista koncertów', eventType: 'music'}
            },
            {
                path: 'add',
                component: EventForm,
                name: 'Add Concert',
                meta: {label: 'Dodaj koncert', eventType: 'music'}
            },
            {
                path: 'order',
                component: EventsOrder,
                name: 'Concerts Order',
                meta: {label: 'Kolejność koncertów', eventType: 'music'}
            },
            {
                path: ':id',
                component: EventForm,
                name: 'Edit Concert',
                hidden: true,
                meta: {label: 'Edytuj koncert', eventType: 'music'}
            }
        ]
    },
    {
        path: '/events/films',
        component: Home,
        iconCls: 'fa fa-video-camera',
        meta: {label: 'Filmy - Kino'},
        children: [
            {
                path: '', component: EventsList, name: 'Films List', meta: {label: 'Lista filmów', eventType: 'cinema'}
            },
            {
                path: 'add', component: EventForm, name: 'Add Film', meta: {label: 'Dodaj film', eventType: 'cinema'}
            },
            {
                path: 'order',
                component: EventsOrder,
                name: 'Films Order',
                meta: {label: 'Kolejność filmów', eventType: 'cinema'}
            },
            {
                path: ':id',
                component: EventForm,
                name: 'Edit Film',
                hidden: true,
                meta: {label: 'Edytuj film', eventType: 'cinema'}
            }
        ]
    },
    {
        path: '/events/seances',
        component: Home,
        iconCls: 'fa fa-child',
        meta: {label: 'Teatr'},
        children: [
            {
                path: '',
                component: EventsList,
                name: 'Spectacles List',
                meta: {label: 'Lista spektakli', eventType: 'theater'}
            },
            {
                path: 'add',
                component: EventForm,
                name: 'Add Spectacle',
                meta: {label: 'Dodaj spektakl', eventType: 'theater'}
            },
            {
                path: 'order',
                component: EventsOrder,
                name: 'Spectacles Order',
                meta: {label: 'Kolejność spektakli', eventType: 'theater'}
            },
            {
                path: 'registrations',
                component: RegistrationsList,
                name: 'Registrations List',
                meta: {label: 'Zapisy'}
            },
            {
                path: 'registration-settings',
                component: RegistrationSettings,
                name: 'Registration Settings',
                meta: {label: 'Ustawienia zapisów'}
            },
            {
                path: 'registration-regulations',
                redirect: {name: 'Edit Page', params: {slug: 'regulamin-do-spektakli'}},
                name: 'Edit Registrations Regulations',
                meta: {label: 'Regulamin zapisów'}
            },
            {
                path: ':id',
                component: EventForm,
                name: 'Edit Spectacle',
                hidden: true,
                meta: {label: 'Edytuj spektakl', eventType: 'theater'}
            }
        ]
    },
    {
        path: '/events/others',
        component: Home,
        iconCls: 'fa fa-question',
        meta: {label: 'Wydarzenia miasteczko'},
        children: [
            {
                path: '',
                component: EventsList,
                name: 'OtherEvents List',
                meta: {label: 'Lista wydarzeń', eventType: 'others'}
            },
            {
                path: 'add',
                component: EventForm,
                name: 'Add OtherEvent',
                meta: {label: 'Dodaj wydarzenie', eventType: 'others'}
            },
            {
                path: 'order',
                component: EventsOrder,
                name: 'OtherEvent Order',
                meta: {label: 'Kolejność wydarzeń', eventType: 'others'}
            },
            {
                path: ':id',
                component: EventForm,
                name: 'Edit OtherEvent',
                hidden: true,
                meta: {label: 'Edytuj wydarzenie', eventType: 'others'}
            }
        ]
    },
    {
        path: '/stands',
        component: Home,
        iconCls: 'fa fa-truck',
        meta: {label: 'Stoiska'},
        children: [
            {
                path: 'categories/', component: CategoriesList, name: 'StandCategories List', meta: {label: 'Kategorie'}
            },
            {
                path: 'categories/add',
                component: CategoryForm,
                name: 'Add StandCategory',
                hidden: true,
                meta: {label: 'Dodaj kategorię'}
            },
            {
                path: 'categories/:id',
                component: CategoryForm,
                name: 'Edit StandCategory',
                hidden: true,
                meta: {label: 'Edytuj kategorie'}
            },
            {
                path: '', component: StandsList, name: 'Stands List', meta: {label: 'Lista stoisk'}
            },
            {
                path: 'add', component: StandForm, name: 'Add Stand', meta: {label: 'Dodaj stoisko'}
            },
            {
                path: ':id', component: StandForm, name: 'Edit Stand', hidden: true, meta: {label: 'Edytuj stoisko'}
            }
        ]
    },
    {
        path: '/instagram',
        component: Home,
        iconCls: 'fa fa-instagram',
        meta: {label: 'Instagram'},
        children: [
            {
                path: '', component: FoldersList, name: 'Folders List', meta: {label: 'Lista folderów'}
            },
            {
                path: 'add', component: FolderForm, name: 'Add Folder', meta: {label: 'Dodaj folder'}
            },
            {
                path: ':id', component: FolderForm, name: 'Edit Folder', hidden: true, meta: {label: 'Edytuj folder'}
            }
        ]
    },
    {
        path: '/forms',
        component: Home,
        iconCls: 'fa fa-vcard',
        meta: {label: 'Formularze'},
        children: [
            {
                path: '', component: CustomFormsList, name: 'CustomForms List', meta: {label: 'Lista formularzy'}
            },
            {
                path: 'add', component: CustomForm, name: 'Add CustomForm', meta: {label: 'Dodaj formularz'}
            },
            {
                path: ':id',
                component: CustomForm,
                name: 'Edit CustomForm',
                hidden: true,
                meta: {label: 'Edytuj formularz'}
            }
        ]
    },
    {
        path: '/settings',
        component: Home,
        iconCls: 'fa fa-cog',
        meta: {label: 'Ustawienia'},
        children: [
            {
                path: '', component: SettingsForm, name: 'Settings Form', meta: {label: 'Konfiguracja strony'}
            },
            {
                path: 'colors', component: ColorsList, name: 'Colors List', meta: {label: 'Lista kolorów'}
            },
            {
                path: 'colors/add', component: ColorForm, name: 'Add Color', hidden: true, meta: {label: 'Dodaj kolor'}
            },
            {
                path: 'colors/:id', component: ColorForm, name: 'Edit Color', hidden: true, meta: {label: 'Edytuj kolor'}
            }

        ]
    },
    {
        path: '/attachments',
        component: Home,
        iconCls: 'fa fa-download',
        meta: {label: 'Załączniki'},
        children: [
            {
                path: '', component: AttachmentsList, name: 'Attachments List', meta: {label: 'Lista załączników'}
            }
        ]
    },
    {
        path: '*',
        hidden: true,
        redirect: {path: '/404'}
    }
];

const router = new VueRouter({
    routes
})

router.beforeEach((to, from, next) => {
    const isUserLoggedIn = window.localStorage.getItem('token')
    if (!to.meta.guests && !isUserLoggedIn) {
        next({name: 'Login', query: {next: to.path}})
        return
    }
    next()
})

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js